import React, { useState } from "react";
import Popup from "reactjs-popup";
import "../../App.css";
import { MultiSelect } from "react-multi-select-component";
import { Button } from "reactstrap";

export default (props) => {
  const [selected, setSelected] = useState([]);

  const models = props.models;
  let options = [];
  for (let i = 0; i < models.length; i++) {
    const model = models[i];
    let option = {
      label: model.fname + " " + model.lname + " (" + model.email + ")",
      value: props.collect === "email" ? model.email : model.id,
    };
    options = options.concat(option);
  }

  return (
    <Popup
      contentStyle={{ width: 500, height: 500 }}
      trigger={props.button}
      modal
      nested
    >
      {(close) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: 0,
            height: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              height: 45,
              width: "100%",
              backgroundColor: "gray",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: "bold", color: "white" }}>
              {props.title}
            </div>
          </div>
          <div style={{ padding: 10 }}>
            {/* <pre>{JSON.stringify(selected)}</pre> */}
            <MultiSelect
              options={options}
              value={selected}
              onChange={setSelected}
              labelledBy="Choose..."
            />
          </div>
          <div
            style={{
              padding: 10,
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}
          >
            <Button
              className="btn-block"
              style={{
                backgroundColor: "green",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                props.onDone(selected);
                close();
              }}
            >
              Done
            </Button>
            <Button
              className="btn-block"
              style={{
                marginLeft: 15,
                backgroundColor: "red",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                close();
              }}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </Popup>
  );
};
